// Test
const TEST_ERROR = 'Design Pro: Test error';

// Save
const UPDATE_DESIGN_FAILED = 'Design Pro:Failed to update design';
const UPDATE_DESIGN_HDF_FAILED = 'Design Pro:Failed to update design hdf';
const CREATE_DESIGN_FAILED = 'Design Pro:Failed to create design';
const SAVE_DESIGN_FAILED = 'Design Pro: Failed to save design';
const GET_UPLOAD_URLS_FAILED = 'Design Pro: Failed to get upload urls';

// Split
const CHANGE_SPLIT_TOOL_ORIENTATION_FAILED =
  'Design Pro: Failed to change split tool orientation';
const CONFIRM_SPLIT_FAILED = 'Design Pro: Failed to confirm split(s)';
const CONFIRM_DELETE_SPLIT_FAILED =
  'Design Pro: Failed to confirm delete split(s)';
const DRAW_SPLIT_INDICATOR_FAILED =
  'Design Pro: Failed to draw split indicator';
const INITIALIZE_SPLIT_TOOL_FAILED =
  'Design Pro: Failed to initialize split tool';
const SET_SPLIT_RANGE_FAILED = 'Design Pro: Failed to set split range';
const UPDATE_SPLIT_FACADE_FAILED = 'Design Pro: Failed to update split facade';
const CORRUPT_SEGMENTATION_TREE =
  'Design Pro: Split resulted in corrupt segmentation tree';

// Measure
const CALCULATE_MEASUREMENTS_FAILED =
  'Design Pro: Failed to calculate measurements';
const FETCHING_MEASUREMENTS_FAILED =
  'Design Pro: Failed to fetch measurements data';

// Undo/Redo
const UNDO_REDO_OPERATION_FAILED = 'Design Pro: Undo/Redo Operation Failed';

export default {
  CALCULATE_MEASUREMENTS_FAILED,
  CHANGE_SPLIT_TOOL_ORIENTATION_FAILED,
  CONFIRM_DELETE_SPLIT_FAILED,
  CONFIRM_SPLIT_FAILED,
  CORRUPT_SEGMENTATION_TREE,
  CREATE_DESIGN_FAILED,
  DRAW_SPLIT_INDICATOR_FAILED,
  FETCHING_MEASUREMENTS_FAILED,
  GET_UPLOAD_URLS_FAILED,
  INITIALIZE_SPLIT_TOOL_FAILED,
  SAVE_DESIGN_FAILED,
  SET_SPLIT_RANGE_FAILED,
  TEST_ERROR,
  UNDO_REDO_OPERATION_FAILED,
  UPDATE_DESIGN_FAILED,
  UPDATE_SPLIT_FACADE_FAILED,
};
